import { IFrameAdminMenuItem } from 'lqa-ui/lib/Frames/Admin/index';
import { generateLocaledUrl } from './generateLocaledUrl';
import { AccessType } from '../enums/AccessType';
import { IMenuItem } from '../interfaces/menu/MenuItems';
import { getItem } from './storage';
import { includes, split } from 'lodash';
import { getUserData } from './user/getUserData';
import { getFeatureFlagSync } from './featureFlags/featureFlagIntegrationNew';

const anyAdminUser = [
    { type: AccessType.brandClientUser, mustBeAdmin: true },
    { type: AccessType.clientUser, mustBeAdmin: true },
    { type: AccessType.masterClientUser, mustBeAdmin: true },
    { type: AccessType.regionalClientUser, mustBeAdmin: true },
    { type: AccessType.hotelUser, mustBeAdmin: true },
];

export const getMenuItems = (
    accType,
    clientId,
    isUserAdmin,
    isBlackoutEditEnabled,
    path,
    urlSegment,
    isViewer,
    isDepartmentManager,
    isTrainer,
    myLqaSubscriptionPurchased: boolean,
    originalUser?
) => {
    const menuItems: IFrameAdminMenuItem[] = [];
    const userMenuItems: IFrameAdminMenuItem[] = [];
    const userData = getUserData(true);

    let test = getItem('cachedBrandSelected');
    if (!test) {
        test = '0';
    } else {
        test = getItem('cachedBrandSelected').toString();
    }
    const createMenuItem = (
        item: IMenuItem,
        lastPath: string[] = []
    ) => {
        if (item.allowedUserTypes && !item.allowedUserTypes.find(i => (i.type === accType) && (i.mustBeAdmin ? isUserAdmin : true))) {
            return;
        }
        const currentPath: string[] = lastPath.slice(0);
        currentPath.push(item.path);
        const newItem: any = {
            name: item.name,
            href: currentPath.includes('lqagroup') ? 'https://lqagroup.com/mylqa/' : generateLocaledUrl(path, `${currentPath.join('/')}/`),
            active: urlSegment.includes(currentPath.join('/')),
            pendoId: item.pendoId,
            openInNewTab: item.openInNewTab,
        };
        if (item.items && item.items.length > 0) {
            newItem.submenus = item.items.map((subItem) => createMenuItem(subItem, currentPath)).filter(i => !!i);
            if (newItem.submenus.length > 0) {
                newItem.href = newItem.submenus[0].href;
            } else {
                return;
            }
        }
        return newItem;
    };

    if (({
        LQAAdmin: false,
        LQABasic: false,
        masterClientUser: true,
        clientUser: true,
        brandClientUser: true,
        regionalClientUser: true,
        hotelUser: true,
    })[accType]) {
        const allowedUserTypesSelfAssessment = [
            { type: AccessType.brandClientUser, mustBeAdmin: true },
            { type: AccessType.clientUser, mustBeAdmin: false },
            { type: AccessType.masterClientUser, mustBeAdmin: false },
            { type: AccessType.regionalClientUser, mustBeAdmin: true },
            { type: AccessType.hotelUser, mustBeAdmin: true },
        ];
        if (isDepartmentManager) {
            allowedUserTypesSelfAssessment.push({ type: AccessType.hotelUser, mustBeAdmin: !isDepartmentManager });
        }
        const user = getItem('user').user;
        const userMenuTree: IMenuItem[] = (originalUser
            ? [
                {
                    name: 'Logout',
                    path: 'logout',
                },
            ]
            : [
                {
                    name: 'My Account',
                    path: 'my-account',
                },
                {
                    name: 'Logout',
                    path: 'logout',
                },
            ]);
        const menuTree: IMenuItem[] = [
            {
                name: 'Upfront Training',
                path: 'upfront',
                items: [
                    {
                        name: 'Training Home',
                        path: 'about-us',
                        allowedUserTypes: [
                            { type: AccessType.brandClientUser, mustBeAdmin: false },
                            { type: AccessType.clientUser, mustBeAdmin: false },
                            { type: AccessType.masterClientUser, mustBeAdmin: false },
                            { type: AccessType.regionalClientUser, mustBeAdmin: false },
                            { type: AccessType.hotelUser, mustBeAdmin: false },
                        ],
                    },
                    {
                        name: 'Training Summary',
                        path: 'summary',
                        allowedUserTypes: [
                            { type: AccessType.brandClientUser, mustBeAdmin: true },
                            { type: AccessType.clientUser, mustBeAdmin: false },
                            { type: AccessType.masterClientUser, mustBeAdmin: false },
                            { type: AccessType.regionalClientUser, mustBeAdmin: true },
                            { type: AccessType.hotelUser, mustBeAdmin: true },
                        ],
                    },
                ],
            },
            {
                name: 'Self Assessments',
                path: 'self-assessments',
                items: [
                    {
                        name: 'Self Assessments',
                        path: 'self-assessments',
                        allowedUserTypes: [
                            { type: AccessType.brandClientUser, mustBeAdmin: false },
                            { type: AccessType.clientUser, mustBeAdmin: false },
                            { type: AccessType.masterClientUser, mustBeAdmin: false },
                            { type: AccessType.regionalClientUser, mustBeAdmin: false },
                            { type: AccessType.hotelUser, mustBeAdmin: false },
                        ],
                    },
                    {
                        name: 'Self Assessments Trends',
                        path: 'trends',
                        allowedUserTypes: anyAdminUser,
                    },
                    {
                        name: 'Self Assessment Summary',
                        path: 'self-assessment-summary',
                        allowedUserTypes: allowedUserTypesSelfAssessment,
                    },
                ],
            },
            {
                name: 'Action Plans',
                path: 'action-plans',
                items: [
                    {
                        name: 'Action Plans',
                        path: 'action-plans',
                        allowedUserTypes: [
                            { type: AccessType.brandClientUser, mustBeAdmin: false },
                            { type: AccessType.clientUser, mustBeAdmin: false },
                            { type: AccessType.masterClientUser, mustBeAdmin: false },
                            { type: AccessType.regionalClientUser, mustBeAdmin: false },
                            { type: AccessType.hotelUser, mustBeAdmin: false },
                        ],
                    },
                    {
                        name: 'Action Plan Summary',
                        path: 'summary',
                        allowedUserTypes: [
                            { type: AccessType.brandClientUser, mustBeAdmin: true },
                            { type: AccessType.clientUser, mustBeAdmin: false },
                            { type: AccessType.masterClientUser, mustBeAdmin: false },
                            { type: AccessType.regionalClientUser, mustBeAdmin: true },
                            { type: AccessType.hotelUser, mustBeAdmin: !isDepartmentManager },
                        ],
                    },
                ],
            },
            // {
            //     name: 'Upfront Training',
            //     path: 'upfront',
            //     items: [
            //         {
            //             name: 'About Us',
            //             path: 'about-us',
            //             allowedUserTypes: [
            //                 { type: AccessType.brandClientUser, mustBeAdmin: true },
            //                 { type: AccessType.clientUser, mustBeAdmin: false },
            //                 { type: AccessType.masterClientUser, mustBeAdmin: false },
            //                 { type: AccessType.regionalClientUser, mustBeAdmin: true },
            //                 { type: AccessType.hotelUser, mustBeAdmin: true },
            //             ],
            //         },
            //         {
            //             name: 'Our Curriculum',
            //             path: 'our-curriculum',
            //             allowedUserTypes: [
            //                 { type: AccessType.brandClientUser, mustBeAdmin: true },
            //                 { type: AccessType.clientUser, mustBeAdmin: false },
            //                 { type: AccessType.masterClientUser, mustBeAdmin: false },
            //                 { type: AccessType.regionalClientUser, mustBeAdmin: true },
            //                 { type: AccessType.hotelUser, mustBeAdmin: true },
            //             ],
            //         },
            //         {
            //             name: 'Extended Feedback',
            //             path: 'extended-feedback',
            //             allowedUserTypes: [
            //                 { type: AccessType.brandClientUser, mustBeAdmin: true },
            //                 { type: AccessType.clientUser, mustBeAdmin: false },
            //                 { type: AccessType.masterClientUser, mustBeAdmin: false },
            //                 { type: AccessType.regionalClientUser, mustBeAdmin: true },
            //                 { type: AccessType.hotelUser, mustBeAdmin: true },
            //             ],
            //         },
            //         {
            //             name: 'Contact Upfront',
            //             path: 'contact-upfront',
            //             allowedUserTypes: [
            //                 { type: AccessType.brandClientUser, mustBeAdmin: true },
            //                 { type: AccessType.clientUser, mustBeAdmin: false },
            //                 { type: AccessType.masterClientUser, mustBeAdmin: false },
            //                 { type: AccessType.regionalClientUser, mustBeAdmin: true },
            //                 { type: AccessType.hotelUser, mustBeAdmin: true },
            //             ],
            //         }
            //     ]
            // }
        ];

        if (!isViewer) {
            menuTree.unshift({
                name: 'Hotel',
                path: 'hotel',
                pendoId: 'pendo-step-2',
                items: [
                    {
                        name: 'Dashboard',
                        path: 'dashboard',
                        allowedUserTypes: [
                            { type: AccessType.brandClientUser, mustBeAdmin: false },
                            { type: AccessType.clientUser, mustBeAdmin: false },
                            { type: AccessType.masterClientUser, mustBeAdmin: false },
                            { type: AccessType.regionalClientUser, mustBeAdmin: false },
                            { type: AccessType.hotelUser, mustBeAdmin: false },
                        ],
                        pendoId: 'pendo-step-3',
                    },
                    {
                        name: 'Assessment Summary',
                        path: 'assessment-summary',
                        allowedUserTypes: [
                            { type: AccessType.brandClientUser, mustBeAdmin: false },
                            { type: AccessType.clientUser, mustBeAdmin: false },
                            { type: AccessType.masterClientUser, mustBeAdmin: false },
                            { type: AccessType.regionalClientUser, mustBeAdmin: false },
                            { type: AccessType.hotelUser, mustBeAdmin: false },
                        ],
                    },
                    {
                        name: 'Benchmarking',
                        path: 'benchmarking',
                        allowedUserTypes: [
                            { type: AccessType.brandClientUser, mustBeAdmin: false },
                            { type: AccessType.clientUser, mustBeAdmin: false },
                            { type: AccessType.masterClientUser, mustBeAdmin: false },
                            { type: AccessType.regionalClientUser, mustBeAdmin: false },
                            { type: AccessType.hotelUser, mustBeAdmin: false },
                        ],
                    },
                    {
                        name: 'Trends',
                        path: 'trends',
                        allowedUserTypes: [
                            { type: AccessType.brandClientUser, mustBeAdmin: false },
                            { type: AccessType.clientUser, mustBeAdmin: false },
                            { type: AccessType.masterClientUser, mustBeAdmin: false },
                            { type: AccessType.regionalClientUser, mustBeAdmin: false },
                            { type: AccessType.hotelUser, mustBeAdmin: false },
                        ],
                    },
                    {
                        name: 'Missed standards',
                        path: 'missed-standards',
                        allowedUserTypes: [
                            { type: AccessType.brandClientUser, mustBeAdmin: false },
                            { type: AccessType.clientUser, mustBeAdmin: false },
                            { type: AccessType.masterClientUser, mustBeAdmin: false },
                            { type: AccessType.regionalClientUser, mustBeAdmin: false },
                            { type: AccessType.hotelUser, mustBeAdmin: false },
                        ],
                    },
                    {
                        name: 'Additional Assessments',
                        path: 'additional-assessment',
                        allowedUserTypes: [
                            { type: AccessType.brandClientUser, mustBeAdmin: false },
                            { type: AccessType.clientUser, mustBeAdmin: false },
                            { type: AccessType.masterClientUser, mustBeAdmin: false },
                            { type: AccessType.regionalClientUser, mustBeAdmin: false },
                            { type: AccessType.hotelUser, mustBeAdmin: false },
                        ],
                    },
                    // {
                    //     name: 'Additional Assessments',
                    //     path: 'events-summary',
                    //     allowedUserTypes: [
                    //         { type: AccessType.brandClientUser, mustBeAdmin: false },
                    //         { type: AccessType.clientUser, mustBeAdmin: false },
                    //         { type: AccessType.masterClientUser, mustBeAdmin: false },
                    //         { type: AccessType.regionalClientUser, mustBeAdmin: false },
                    //         { type: AccessType.hotelUser, mustBeAdmin: false },
                    //     ],
                    // },
                ],
            });

            const showBrandMenu = () => {
                if (includes(split(Env.RESTRICT_BRAND_FOR_AMAN, ','), test)) {
                    return [
                        { type: AccessType.brandClientUser, mustBeAdmin: false },
                        { type: AccessType.clientUser, mustBeAdmin: false },
                        { type: AccessType.masterClientUser, mustBeAdmin: false },
                    ];
                }
                return [
                    { type: AccessType.brandClientUser, mustBeAdmin: false },
                    { type: AccessType.clientUser, mustBeAdmin: false },
                    { type: AccessType.masterClientUser, mustBeAdmin: false },
                    { type: AccessType.regionalClientUser, mustBeAdmin: false },
                    { type: AccessType.hotelUser, mustBeAdmin: false },
                ];
            };

            if (
                !includes(split(Env.HIDE_BRAND_MENU, ','), test)
            ) {
                menuTree.unshift({
                    name: 'Brand',
                    path: 'brand',
                    items: [
                        {
                            name: 'Dashboard',
                            path: 'dashboard',
                            allowedUserTypes: showBrandMenu(),
                        },
                        {
                            name: 'Assessment Summary',
                            path: 'assessment-summary',
                            allowedUserTypes: showBrandMenu(),
                        },
                        {
                            name: 'Benchmarking',
                            path: 'benchmarking',
                            allowedUserTypes: showBrandMenu(),
                        },
                        {
                            name: 'Trends',
                            path: 'trends',
                            allowedUserTypes: showBrandMenu(),
                        },
                        {
                            name: 'Missed standards',
                            path: 'missed-standards',
                            allowedUserTypes: showBrandMenu(),
                        },
                    ],
                });
            }

            menuTree.push({
                name: 'myLQA',
                path: 'myLQA',
                openInNewTab: true,
                items: [
                    {
                        name: 'Visit myLQA Site',
                        path: 'lqagroup',
                        openInNewTab: true,
                        allowedUserTypes: [
                            { type: AccessType.brandClientUser, mustBeAdmin: true },
                            { type: AccessType.clientUser, mustBeAdmin: true },
                            { type: AccessType.masterClientUser, mustBeAdmin: false },
                            { type: AccessType.regionalClientUser, mustBeAdmin: true },
                            { type: AccessType.hotelUser, mustBeAdmin: true },
                        ],
                    },
                ],
            });

            menuTree.find(o => o.path === 'myLQA')!.items!.push({
                name: 'myLQA Subscription',
                path: 'mylqa-subscription',
                allowedUserTypes: [
                    { type: AccessType.brandClientUser, mustBeAdmin: true },
                    { type: AccessType.clientUser, mustBeAdmin: true },
                    { type: AccessType.masterClientUser, mustBeAdmin: true },
                    { type: AccessType.regionalClientUser, mustBeAdmin: true },
                    { type: AccessType.hotelUser, mustBeAdmin: true },
                ],
            });

            if (myLqaSubscriptionPurchased) {
                    menuTree.find(o => o.path === 'myLQA')!.items!.push({
                        name: 'Manage Users',
                        path: 'users',
                        allowedUserTypes: [
                            { type: AccessType.brandClientUser, mustBeAdmin: true },
                            { type: AccessType.clientUser, mustBeAdmin: true },
                            { type: AccessType.masterClientUser, mustBeAdmin: false },
                            { type: AccessType.regionalClientUser, mustBeAdmin: true },
                            { type: AccessType.hotelUser, mustBeAdmin: true },
                        ],
                    },
                    {
                        name: 'User Bulk Upload',
                        path: 'users/upload-mylqa-user',
                        allowedUserTypes: [
                            { type: AccessType.brandClientUser, mustBeAdmin: true },
                            { type: AccessType.clientUser, mustBeAdmin: true },
                            { type: AccessType.masterClientUser, mustBeAdmin: false },
                            { type: AccessType.regionalClientUser, mustBeAdmin: true },
                            { type: AccessType.hotelUser, mustBeAdmin: true },
                        ],
                    });
                    menuTree.find(o => o.path === 'myLQA')!.items!.push({
                        name: 'myAudit Checklists',
                        path: 'my-audit-checklist',
                        allowedUserTypes: [
                            { type: AccessType.brandClientUser, mustBeAdmin: true },
                            { type: AccessType.clientUser, mustBeAdmin: true },
                            { type: AccessType.masterClientUser, mustBeAdmin: false },
                            { type: AccessType.regionalClientUser, mustBeAdmin: true },
                            { type: AccessType.hotelUser, mustBeAdmin: true },
                        ],
                    });
                    menuTree.find(o => o.path === 'myLQA')!.items!.push({
                        name: 'myAudit Overview',
                        path: 'my-audit-overview',
                        allowedUserTypes: [
                            { type: AccessType.brandClientUser, mustBeAdmin: false },
                            { type: AccessType.clientUser, mustBeAdmin: false },
                            { type: AccessType.masterClientUser, mustBeAdmin: false },
                            { type: AccessType.regionalClientUser, mustBeAdmin: false },
                            { type: AccessType.hotelUser, mustBeAdmin: false },
                        ],
                    });
                    menuTree.find(o => o.path === 'myLQA')!.items!.push(
                        {
                            name: 'News Feed',
                            path: 'news-feed',
                            allowedUserTypes: [
                              {type: AccessType.brandClientUser, mustBeAdmin: true},
                              {type: AccessType.clientUser, mustBeAdmin: true},
                              {type: AccessType.masterClientUser, mustBeAdmin: false},
                              {type: AccessType.regionalClientUser, mustBeAdmin: true},
                              {type: AccessType.hotelUser, mustBeAdmin: true},
                            ],
                        }
                    );
                }

            menuTree.push({
                name: 'Management',
                path: 'management',
                items: [
                    {
                        name: 'Manage Users',
                        path: 'users',
                        allowedUserTypes: [
                            { type: AccessType.brandClientUser, mustBeAdmin: true },
                            { type: AccessType.clientUser, mustBeAdmin: true },
                            { type: AccessType.masterClientUser, mustBeAdmin: false },
                            { type: AccessType.regionalClientUser, mustBeAdmin: true },
                            { type: AccessType.hotelUser, mustBeAdmin: true },
                        ],
                    },
                    {
                        name: 'Additional Reports',
                        path: 'additional-reports',
                        allowedUserTypes: [
                            { type: AccessType.brandClientUser, mustBeAdmin: false },
                            { type: AccessType.clientUser, mustBeAdmin: false },
                            { type: AccessType.masterClientUser, mustBeAdmin: false },
                            { type: AccessType.regionalClientUser, mustBeAdmin: false },
                        ],
                    },
                    {
                        name: 'Site Usage',
                        path: 'site-usage',
                        allowedUserTypes: [
                            { type: AccessType.brandClientUser, mustBeAdmin: false },
                            { type: AccessType.clientUser, mustBeAdmin: false },
                            { type: AccessType.masterClientUser, mustBeAdmin: false },
                            { type: AccessType.regionalClientUser, mustBeAdmin: true },
                            { type: AccessType.hotelUser, mustBeAdmin: true },
                        ],
                    },
                ],
            });
            menuTree.find(o => o.path === 'upfront')!.items!.push({
                name: 'Assign Training',
                path: 'assign',
                allowedUserTypes: [
                    { type: AccessType.brandClientUser, mustBeAdmin: false },
                    { type: AccessType.clientUser, mustBeAdmin: false },
                    { type: AccessType.masterClientUser, mustBeAdmin: false },
                    { type: AccessType.regionalClientUser, mustBeAdmin: false },
                    { type: AccessType.hotelUser, mustBeAdmin: false },
                ],
            });

            menuTree.find(o => o.path === 'action-plans')!.items!.push({
                name: 'New Action Plan',
                path: 'add-action-plan',
                allowedUserTypes: [
                    { type: AccessType.brandClientUser, mustBeAdmin: false },
                    { type: AccessType.clientUser, mustBeAdmin: false },
                    { type: AccessType.masterClientUser, mustBeAdmin: false },
                    { type: AccessType.regionalClientUser, mustBeAdmin: false },
                    { type: AccessType.hotelUser, mustBeAdmin: false },
                ],
            });

            menuTree.find(o => o.path === 'self-assessments')!.items!.push({
                name: 'New Self Assessment',
                path: 'add-self-assessment',
                allowedUserTypes: [
                    { type: AccessType.brandClientUser, mustBeAdmin: false },
                    { type: AccessType.clientUser, mustBeAdmin: false },
                    { type: AccessType.masterClientUser, mustBeAdmin: false },
                    { type: AccessType.regionalClientUser, mustBeAdmin: false },
                    { type: AccessType.hotelUser, mustBeAdmin: false },
                ],
            });

            if (isBlackoutEditEnabled) {
                menuTree.find(o => o.path === 'management')!.items!.push({
                    name: 'Block Out Dates',
                    path: 'blackouts',
                    allowedUserTypes: [
                        { type: AccessType.brandClientUser, mustBeAdmin: false },
                        { type: AccessType.clientUser, mustBeAdmin: false },
                        { type: AccessType.masterClientUser, mustBeAdmin: false },
                        { type: AccessType.regionalClientUser, mustBeAdmin: false },
                        { type: AccessType.hotelUser, mustBeAdmin: false },
                    ],
                });
            }
        }
        if (!isViewer) {
            menuTree.unshift({
                    name: 'Global',
                    path: 'globalreports',
            });
        }

        // Conditionally add Feature Flag Playground to Global section
        const featureFlagPlaygroundFlag = getFeatureFlagSync('featureFlagPlayground');
        if (featureFlagPlaygroundFlag) {
            // Add Feature Flag Playground to Global section (always visible for testing)
            menuTree.push({
                name: 'Feature Flag Playground',
                path: 'feature-flag-playground',
            });
        }

        menuItems.push(...menuTree.map((menuItem) => createMenuItem(menuItem)).filter(i => !!i));
        userMenuItems.push(...userMenuTree.map((menuItem) => createMenuItem(menuItem)).filter(i => !!i));
    }

    if (({
        LQAAdmin: true,
        LQABasic: false,
    })[accType]) {
        const userMenuTree: IMenuItem[] = [
            {
                name: 'My Account',
                path: 'admin/my-account',
            },
            {
                name: 'Logout',
                path: 'admin/logout',
            },
        ];
        const menuTree: IMenuItem[] = [
            {
                name: 'Clients',
                path: 'admin/clients',
                items: [
                    {
                        name: 'All Clients',
                        path: 'clients',
                    },
                    {
                        name: 'Client Users',
                        path: 'users',
                    },
                    {
                        name: 'Brands',
                        path: 'brands',
                    },
                    {
                        name: 'Hotels',
                        path: 'hotels',
                    },
                    {
                        name: 'Manage Comp Sets',
                        path: 'comp-sets',
                    },
                    {
                        name: 'Custom Comp Sets',
                        path: 'custom-comp-sets',
                    },
                    {
                        name: 'Locations',
                        path: 'locations',
                    },
                    {
                        name: 'Custom Regions',
                        path: 'custom-regions',
                    },
                ],
            },
            {
                name: 'Assessments',
                path: 'admin/assessments',
                items: [
                    {
                        name: 'Assessments',
                        path: 'assessments',
                    },
                    {
                        name: 'Published Assessments',
                        path: 'published-assessments',
                    },
                    {
                        name: 'Templates',
                        path: `templates`,
                    },
                    {
                        name: 'Standards',
                        path: 'standards',
                    },
                    {
                        name: 'Categories',
                        path: 'categories',
                    },
                ],
            },
            {
                name: 'Upfront Training',
                path: 'admin/upfront-training',
                items: [
                    {
                        name: 'Brands',
                        path: 'brands',
                    },
                    {
                        name: 'Hotels',
                        path: 'hotels',
                    },
                    {
                        name: 'Feedback',
                        path: 'feedback',
                    },
                ],
            },
            // {
            //     name: 'Reports',
            //     path: 'admin/reports',
            //     items: [
            //         {
            //             name: 'Assessment Report',
            //             path: 'assessments',
            //         },
            //         {
            //             name: 'Booking Details Report',
            //             path: 'booking-details',
            //         },
            //         {
            //             name: 'Spotted Report',
            //             path: 'spotted',
            //         },
            //     ],
            // },
            {
                name: 'Management',
                path: 'admin/management',
                items: [
                    {
                        name: 'LQA Users',
                        path: 'lqa-users',
                    },
                    {
                        name: 'Questionnaire',
                        path: 'questionnaire',
                    },
                    {
                        name: 'Questionnaire Report',
                        path: 'questionnaire-report',
                    },
                    // {
                    //     name: 'Training Questionnaire Report',
                    //     path: 'training-questionnaire-report',
                    // },
                    {
                        name: 'Block Out Dates',
                        path: 'blackouts',
                    },
                    {
                        name: 'Booking Report',
                        path: 'booking-report',
                    },
                    {
                        name: 'Spotted Report',
                        path: 'spotted-report',
                    },
                    {
                        name: 'Resources',
                        path: 'resources',
                    },
                    {
                        name: 'News Feed',
                        path: 'news-feed',
                    },
                    {   name: 'myLqa Subscription Summary',
                        path: 'mylqa-subscriptions-summary',
                    },
                ],
            },
            {
                name: 'Control hub [BETA]',
                path: 'admin/control-hub',
            },
        ];
        
        if (Env.BO_FEATURE_FLAG_ENABLED === 'no' && userData.isSchedulePageVisible) {

            const schedulingItems = [
                {
                    name: 'Hotel Scheduling',
                    path: 'hotel-scheduling',
                },
                {
                    name: 'Staff Scheduling',
                    path: 'staff-scheduling',
                },
                {
                    name: 'Roster',
                    path: 'manage-roster',
                },
                {
                    name: 'Office Week Manager',
                    path: 'office-week-manager',
                },
                {
                    name: 'Manage Requests',
                    path: 'manage-requests',
                },
                {
                    name: 'Days Manager',
                    path: 'days-manager',
                },
                {
                    name: 'Additional Scheduling',
                    path: 'additional-scheduling',
                },
            ];

            menuTree.find(o => o.path === 'admin/management')!.items!.push({
                name: 'Holiday Location',
                path: 'holiday-location-main',
            });
            menuTree.push(
                {
                    name: 'Contracting',
                    path: 'admin/contracting',
                    items: [
                        {
                            name: 'Contract Management',
                            path: 'contract-management',
                        },
                        {
                            name: 'Assessment Management',
                            path: 'assessment-management',
                        },
                    ],
                },
                {
                    name: 'Scheduling',
                    path: 'admin/scheduling',
                    items: schedulingItems,
                },
            );
        }
        menuItems.push(...menuTree.map((menuItem) => createMenuItem(menuItem)).filter(i => !!i));
        userMenuItems.push(...userMenuTree.map((menuItem) => createMenuItem(menuItem)).filter(i => !!i));
    }

    if (({
        LQAAdmin: false,
        LQABasic: true,
    })[accType]) {
        const userMenuTree: IMenuItem[] = [
            {
                name: 'My Account',
                path: 'admin/my-account',
            },
            {
                name: 'Logout',
                path: 'admin/logout',
            },
        ];
        const getMenu = () => {
            if (isTrainer) {
                return [
                    {
                        name: 'Hotels',
                        path: 'hotels',
                        pendoId: 'soumitra',
                    },
                    {
                        name: 'Client Users',
                        path: 'users',
                    },

                ];
            }
            return [
                {
                    name: 'Hotels',
                    path: 'hotels',
                    pendoId: 'soumitra',
                },
            ];
        };
        const menuTree: IMenuItem[] = [
            {
                name: 'Clients',
                path: 'admin/clients',
                items: getMenu(),
            },
            {
                name: 'Assessments',
                path: 'admin/assessments',
                items: [
                    {
                        name: 'Assessments',
                        path: 'assessments',
                    },
                    {
                        name: 'Published Assessments',
                        path: 'published-assessments',
                    },
                ],
            },
            {
                name: 'Management',
                path: 'admin/management',
                items: [
                    {
                        name: 'Questionnaire Summary',
                        path: 'questionnaire-summary',
                    },
                    // {
                    //     name: 'Training Questionnaire Summary',
                    //     path: 'training-questionnaire-summary',
                    // },
                    {
                        name: 'Spotted Report',
                        path: 'spotted-report',
                    },
                    {
                        name: 'Resources',
                        path: 'view-resources',
                    },
                ],
            },
        ];
        if (Env.BO_FEATURE_FLAG_ENABLED === 'no' && userData.isSchedulePageVisible) {
            menuTree.push({
                name: 'Scheduling',
                path: 'admin/scheduling',
                items: [
                    {
                        name: 'Roster',
                        path: 'roster',
                    },
                    {
                        name: 'Special Requests',
                        path: 'special-requests',
                    },
                    {
                        name: 'Holiday Requests',
                        path: 'holiday-requests',
                    },
                    {
                        name: 'Partner Availability',
                        path: 'partner-availability',
                    },
                ],
            });
        }
        menuItems.push(...menuTree.map((menuItem) => createMenuItem(menuItem)).filter(i => !!i));
        userMenuItems.push(...userMenuTree.map((menuItem) => createMenuItem(menuItem)).filter(i => !!i));
    }

    return {
        menuItems,
        userMenuItems,
    };
};
